import React from 'react';
import { Link } from 'react-router-dom';
import './LogoWithText.css';

export interface LogoWithTextProps {
  /** Default: wrap in Link to `/` (landing). Set false for static block. */
  asLink?: boolean;
  className?: string;
}

const PUBLIC = process.env.PUBLIC_URL || '';

/**
 * Bir xil o‘lcham va uslub: logo + «ERP» (Navbar va Footer).
 */
export function LogoWithText({ asLink = true, className = '' }: LogoWithTextProps) {
  const rootClass = ['logo-with-text', className].filter(Boolean).join(' ');
  const inner = (
    <>
      <img
        src={`${PUBLIC}/adde-logo-light-trim.png`}
        alt=""
        className="logo-with-text__mark logo-with-text__mark--light"
        decoding="async"
        draggable={false}
      />
      <img
        src={`${PUBLIC}/adde-logo-dark-trim.png`}
        alt=""
        className="logo-with-text__mark logo-with-text__mark--dark"
        decoding="async"
        draggable={false}
      />
      <span className="logo-with-text__erp" aria-hidden>ERP</span>
    </>
  );

  if (asLink) {
    return (
      <Link to="/" className={rootClass} aria-label="Add-e ERP">
        {inner}
      </Link>
    );
  }

  return <div className={rootClass} role="img" aria-label="Add-e ERP">{inner}</div>;
}
